export default {
  headline: {
    fontFamily: 'Anton',
    color: 'rgb(13, 40, 20)',
  },
  text: {
    color: 'rgb(24,23,26)',
    fontFamily: 'Roboto',
  },
  spacer: {
    color: 'rgba(0, 0, 0, 0)',
  },
  button: {
    color: '#f8f9e8',
    fontFamily: 'Roboto',
    borderColor: 'rgb(13, 40, 20)',
    backgroundColor: 'rgb(13, 40, 20)',
  },
  rank: {
    baseColor: 'rgba(251, 180, 2, 1)',
  },
  image: {
    backgroundColor: 'rgba(0, 0, 0, 0)',
  },
  field: {
    color: 'rgb(13, 40, 20)',
    fontFamily: 'Roboto',
    borderColor: '#000000',
    backgroundColor: '#f8f9e8',
  },
  social: {
    color: '#0e2814',
  },
  survey: {
    color: '#f8f9e8',
    borderColor: '#0e2814',
    backgroundColor: '#0e2814',
  },
  wheel: {
    fontFamily: 'Anton',
    color: '#f8f9e8',
    borderColor: 'rgb(0, 0, 0)',
    backgroundColor: '#0e2814',
    secondaryBackgroundColor: '#3e5344',
  },
  voucher: {
    color: 'rgb(24, 23, 26)',
    fontFamily: 'Roboto',
  },
  checkbox: {
    color: '#f8f9e8',
    borderColor: '#3e5344',
    checkboxColor: '#f8f9e8',
    backgroundColor: '#0e2814',
  },
}